var error = {
  translation: {
    error: {
      coreNotFound: 'Falha em obter configurações base',
      domainNotAllowed: 'Você não pode se registrar com um email deste domínio',
      emailAlreadyInUse: 'Email já está em uso',
      insufficientPermissions: 'Permissões insuficientes',
      invalidCurrentPassword: 'Senha atual inválida',
      invalidPermissions: 'Selecione pelo menos uma permissão',
      invalidUsernameOrPassword: 'Nome de usuário ou senha incorretos',
      localRegistrationDisabled: 'O registro de usuários locais foi desabilitado pela administração',
      noInternetConnection: 'Sem conexão com a internet',
      noOidcProfileFound: 'Nenhum perfil OIDC encontrado',
      policyNotAccepted: 'Por favor, aceite os Termos de Serviço e Política de Privacidade',
      registrationDisabled: 'O registro de usuários foi desabilitado pela administração',
      serverConnectionFailed: 'A conexão com o servidor falhou',
      ssoRegistrationDisabled: 'O registro de usuários por SSO foi desabilitado pela administração',
      tooManyFailedAttempts: 'Muitas tentativas sem sucesso - tente novamente mais tarde',
      unknownError: 'Erro desconhecido, tente novamente mais tarde',
      usernameAlreadyInUse: 'Nome de usuário já está em uso',
      weakPassword: 'Por favor, utilize uma senha mais forte',
    },
  },
};

export { error as default };
